/** Staff can add the first lock-code row when a property search has none. */
function canOfferFirstLockCode(state) {
  const row = state || {};
  if (!row.nothingFound) return false;
  if (row.propertyId == null || row.propertyId === '') return false;
  if (row.role == null || row.role === '') return false;
  const roleNum = Number(row.role);
  if (!Number.isFinite(roleNum) || roleNum >= 3) return false;
  return true;
}

module.exports = { canOfferFirstLockCode };
